// eslint-disable-next-line import/extensions
import { useAnalytics as usePackageAnalytics } from '@3plearning/mx-teacher-analytics/react';

// Returns null outside a provider so isolated tests can no-op.
export default function useAnalyticsClient() {
  try {
    return usePackageAnalytics();
  } catch (error) {
    return null;
  }
}
